export default __webpack_public_path__ + "static/feature2-151046f6eb4e5900d416464b3a878180.png";